export type JobDisplayTitleInput = {
  title?: string | null
  lineItems?: Array<{ description?: string | null }> | null
}

/**
 * Single source of truth for how a job is labelled in the UI.
 * Prefer an explicit job title, then a short summary of the first two
 * line-item descriptions, and finally a generic fallback.
 */
export function getJobDisplayTitle(job: JobDisplayTitleInput | null | undefined): string {
  if (job?.title?.trim()) return job.title.trim()
  if (job?.lineItems?.length) {
    const descriptions = job.lineItems
      .slice(0, 2)
      .map((item) => item.description)
      .filter(Boolean)
    if (descriptions.length > 0) {
      const summary = descriptions.join(', ')
      return summary.length > 50 ? `${summary.slice(0, 50)}...` : summary
    }
  }
  return 'New Job'
}
